module.exports = __webpack_public_path__ + "cb279ced148387bc6fcd706761affdde.png";